import {
	GET_TRACKING_DOMAINS_DATA_PENDDING,
	GET_TRACKING_DOMAINS_DATA,
	GET_TRACKING_DOMAINS_DATA_ERROR
} from '../actions/constants';

const initialState = {
	loading: true,
	data: [],
	error: null
};

export const trackingDomainsReducer = (state = initialState, action) => {
	switch (action.type) {
		case GET_TRACKING_DOMAINS_DATA_PENDDING:
			return {
				...state,
				loading: true
			};
		case GET_TRACKING_DOMAINS_DATA:
			return {
				...state,
				loading: false,
				data: action.payload,
				error: null
			};
		case GET_TRACKING_DOMAINS_DATA_ERROR:
			return {
				...state,
				loading: true,
				error: action.payload
			};
		default:
			return state;
	}
};
